import { IState } from '../../store';
import { getIsFromBuilder, getIsFromLeadFactory, getIsFromSeller } from '../newObject';

// TODO: В случае выигрыша редизайна изменить название селектора в NB-1172
export function selectFutureMapVisible(state: IState): boolean {
  const isFromBuilder = getIsFromBuilder(state);
  const isFromSeller = getIsFromSeller(state);
  const isFromLeadFactory = getIsFromLeadFactory(state);

  return isFromBuilder || isFromSeller || isFromLeadFactory;
}
